import apiClient from 'clients/apiClient';
import authHelper from 'helpers/auth';
import config from 'helpers/config';
import Raven from 'raven-js';

/**
 * Initiliaze the auth information for the current user.
 *
 * @param profile
 * @param account
 */
const initializeAuth = (profile, account = null) => {
    // Active user
    authHelper.setUser(profile);

    // Active session
    authHelper.setAccount(account);

    // Adding the user context to raven so that we know which user triggers an issue.
    Raven.setUserContext({
        account_id: account ? account.id : null,
        user_id: profile.id,
    });
};

/**
 * Performs the flow of retrieving and/or setting current account.
 *
 * @param profile
 */
export const fetchAndSetDefaultAccount = (profile) => {
    let account, accounts;

    authHelper.setUser(profile);

    return apiClient.read(`${ config.getApiBaseUrl() }/@me/accounts`).then(function (accountsResponse) {
        accounts = accountsResponse;
    }).then(function () {
        return apiClient.read(`${ config.getApiBaseUrl() }/current-account`).then(function (accountResponse) {
            account = accountResponse;
        });
    }).catch(function () {
        // Select the first available session if available
        if (accounts && accounts.length > 0) {
            return apiClient.create(`${ config.getApiBaseUrl() }/@me/accounts/${ accounts[0].id }/select`).then(function (accountResponse) {
                account = accountResponse;
            });
        }
    }).then(function () {
        authHelper.setAccounts(accounts);

        initializeAuth(profile, account);
    });
};



// WEBPACK FOOTER //
// ./src/services/auth.js